(function () {
  'use strict';

  var ENDPOINT = '';                       // <-- set this to go live for non-Shopify forms
  var FALLBACK_EMAIL = 'info@tetralogicx.com';
  var FALLBACK_PHONE = '+92-42-3577-4046';
  var FALLBACK_WA = '924235774046';

  if (!ENDPOINT && window.console) {
    console.warn('[forms] No ENDPOINT configured in assets/js/forms.js. ' +
      'The lead modal and newsletter forms submit natively to Shopify and ' +
      'are unaffected. All other forms will show direct contact options ' +
      'instead of a success message until ENDPOINT is set.');
  }

  var LABELS = {
    name: 'Full name', email: 'Business email', phone: 'Phone',
    website: 'Website or store URL', company: 'Company', budget: 'Budget',
    service: 'Service', message: 'Project details', store_size: 'Monthly revenue'
  };

  /* Shopify contact-form fields are named contact[name], contact[email],
     etc. Strip that wrapper so label lookups and the summary builder keep
     working the same way they did with plain field names. */
  function bareName(field) {
    var m = /^contact\[(.+)\]$/.exec(field.name || '');
    return m ? m[1] : field.name;
  }

  function labelFor(field) {
    var id = field.id;
    var lab = id && document.querySelector('label[for="' + id + '"]');
    if (lab) return lab.textContent.replace('*', '').trim();
    var wrap = field.closest('.field, .modal-field, .lf');
    lab = wrap && wrap.querySelector('label');
    if (lab) return lab.textContent.replace('*', '').trim();
    return LABELS[bareName(field)] || field.getAttribute('placeholder') || 'This field';
  }

  var errSeq = 0;

  /* The error message is attached directly after its field. Anchoring it to a
     shared wrapper meant one field's clearError() removed another field's
     message, so only the last error ever survived. */
  function ownError(field) {
    var id = field.getAttribute('data-err-id');
    return id ? document.getElementById(id) : null;
  }

  function setError(field, msg) {
    clearError(field);
    field.setAttribute('aria-invalid', 'true');
    var p = document.createElement('p');
    p.className = 'field-error';
    p.id = 'ferr-' + (++errSeq);
    p.textContent = msg;
    field.setAttribute('aria-describedby', p.id);
    field.setAttribute('data-err-id', p.id);
    field.insertAdjacentElement('afterend', p);
    field.classList.add('has-error');
  }

  function clearError(field) {
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
    field.classList.remove('has-error');
    var e = ownError(field);
    if (e) e.remove();
    field.removeAttribute('data-err-id');
  }

  function isBookkeepingField(f) {
    /* fields we never validate or include in summaries: the honeypot, the
       hidden Shopify body field we build ourselves, and Shopify's own
       form_type/utf8 plumbing */
    return f.type === 'hidden' && (f.name === '_gotcha' || f.id === 'lm-body')
      || f.name === 'form_type' || f.name === 'utf8';
  }

  function validate(form) {
    var fields = form.querySelectorAll('input, select, textarea');
    var first = null;
    Array.prototype.forEach.call(fields, function (f) {
      if (isBookkeepingField(f)) return;
      clearError(f);
      var v = (f.value || '').trim();
      var label = labelFor(f);

      if (f.hasAttribute('required') && !v) {
        setError(f, label + ' is required.');
        first = first || f; return;
      }
      if (!v) return;
      if (f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        setError(f, 'That email address looks incomplete. Check for a typo.');
        first = first || f; return;
      }
      if (f.type === 'url' || bareName(f) === 'website') {
        /* accept "brand.com" as well as a full URL */
        if (!/^([a-z]+:\/\/)?[^\s.]+\.[^\s]{2,}$/i.test(v)) {
          setError(f, 'Enter a web address, for example yourbrand.com');
          first = first || f; return;
        }
      }
      if (f.type === 'tel' && v.replace(/[^\d]/g, '').length < 7) {
        setError(f, 'That phone number looks too short.');
        first = first || f;
      }
    });
    if (first) { first.focus(); }
    return !first;
  }

  function statusEl(form) {
    var s = form.querySelector('.form-status');
    if (!s) {
      s = document.createElement('div');
      s.className = 'form-status';
      s.setAttribute('role', 'status');
      s.setAttribute('aria-live', 'polite');
      form.appendChild(s);
    }
    return s;
  }

  function summarise(form) {
    var out = [];
    Array.prototype.forEach.call(form.querySelectorAll('input, select, textarea'), function (f) {
      if (isBookkeepingField(f) || !f.name) return;
      var v = (f.value || '').trim();
      if (v) out.push(labelFor(f) + ': ' + v);
    });
    return out.join('\n');
  }

  function showFallback(form) {
    var body = summarise(form);
    var subject = 'Website enquiry' + (form.dataset.formName ? ', ' + form.dataset.formName : '');
    var mailto = 'mailto:' + FALLBACK_EMAIL +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body);
    var wa = 'https://wa.me/' + FALLBACK_WA + '?text=' + encodeURIComponent(body);

    var s = statusEl(form);
    s.className = 'form-status is-warn';
    s.innerHTML =
      '<strong>This form is not connected to our inbox yet.</strong>' +
      '<p>Rather than lose your message, send it directly. Your details are already filled in.</p>' +
      '<span class="fs-actions">' +
        '<a class="btn btn-p" href="' + mailto + '">Send by email</a>' +
        '<a class="btn btn-s" href="' + wa + '" target="_blank" rel="noopener">Send on WhatsApp</a>' +
        '<a class="fs-tel" href="tel:' + FALLBACK_PHONE.replace(/[^\d+]/g, '') + '">' + FALLBACK_PHONE + '</a>' +
      '</span>';
    s.scrollIntoView({ block: 'nearest' });
  }

  function showSuccess(form) {
    var native = form.nextElementSibling;
    if (native && /success/i.test(native.className || '')) {
      form.style.display = 'none';
      native.style.display = 'block';
      return;
    }
    var s = statusEl(form);
    s.className = 'form-status is-ok';
    s.innerHTML = '<strong>Thanks, that reached us.</strong>' +
      '<p>We reply within one business day with a written response.</p>';
    form.reset();
    s.scrollIntoView({ block: 'nearest' });
  }

  function showError(form, detail) {
    var s = statusEl(form);
    s.className = 'form-status is-err';
    s.innerHTML = '<strong>That did not send.</strong>' +
      '<p>' + (detail || 'Something went wrong on our side.') +
      ' Your details are still here, so you can try again, or email ' +
      '<a href="mailto:' + FALLBACK_EMAIL + '">' + FALLBACK_EMAIL + '</a>.</p>';
    s.scrollIntoView({ block: 'nearest' });
  }

  function submit(form) {
    var btn = form.querySelector('button[type="submit"], .modal-submit, button:not([type="button"])');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); btn.innerHTML = 'Sending…'; }

    var data = new FormData(form);
    data.append('_page', location.pathname);
    data.append('_form', form.dataset.formName || 'form');

    fetch(ENDPOINT, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.ok) { showSuccess(form); }
        else { showError(form, 'The server returned ' + r.status + '.'); }
      })
      .catch(function () {
        showError(form, 'We could not reach the server. Check your connection.');
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); btn.innerHTML = original; }
      });
  }

  /* --- Shopify native forms (lead modal + newsletter) ------------------ */

  function isShopifyContactForm(form) {
    return !!form.querySelector('input[name="form_type"][value="contact"]');
  }

  /* {% form 'customer', id: 'newsletter-form' %} sections tag the submission
     with a hidden contact[tags]=newsletter field. That's the reliable marker
     - id alone isn't, since a store can have more than one newsletter block
     using the same {% form %} pattern with different section ids. */
  function isShopifyNewsletterForm(form) {
    if (!form.querySelector('input[name="form_type"][value="customer"]')) return false;
    var tags = form.querySelector('input[name="contact[tags]"]');
    return !!(tags && tags.value === 'newsletter');
  }

  function openLeadModal(modal) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }

  /* After a native Shopify submit, the browser redirects back to this same
     page. We flag the attempt in sessionStorage right before submitting, and
     the section renders a small inline script telling us whether Shopify
     accepted it. On the next load, reconcile the two and show the right
     modal state. */
  function checkShopifyContactRedirect() {
    var modal = document.getElementById('leadModal');
    var form = document.getElementById('leadModalForm');
    if (!modal || !form) return;

    var pending = false;
    try { pending = sessionStorage.getItem('leadModalPending') === '1'; } catch (err) { /* ignore */ }
    if (!pending) return;

    try { sessionStorage.removeItem('leadModalPending'); } catch (err) { /* ignore */ }

    if (window.__leadModalPostedSuccessfully) {
      openLeadModal(modal);
      showSuccess(form);
    } else if (window.__leadModalPostError) {
      openLeadModal(modal);
      showError(form, 'Shopify could not process the form.');
    }
  }

  /* live character count for any textarea paired with [data-count-for] */
  function counter(el) {
    var field = document.getElementById(el.getAttribute('data-count-for'));
    if (!field) return;
    var max = field.getAttribute('maxlength');
    if (!max) return;
    var paint = function () { el.textContent = field.value.length + '/' + max; };
    field.addEventListener('input', paint);
    paint();
  }

  function wire(form) {
    if (form.dataset.wired) return;
    form.dataset.wired = '1';

    var shopifyContact = isShopifyContactForm(form);
    var shopifyNewsletter = isShopifyNewsletterForm(form);
    var shopifyNative = shopifyContact || shopifyNewsletter;

    if (!shopifyNative) {
      /* the inline handlers faked success; they must not survive */
      form.removeAttribute('onsubmit');
      form.setAttribute('novalidate', 'novalidate');
    }

    /* Newsletter forms are tiny (just an email field) and Shopify's own
       liquid already renders form.errors.messages.email on an invalid or
       empty address - so skip the honeypot, the custom validate() pass and
       the submit hijack entirely. Nothing in this script should touch them
       beyond letting them submit. */
    if (shopifyNewsletter) return;

    /* simple bot trap (Shopify has its own spam checks, but this costs
       nothing extra and keeps behaviour consistent) */
    if (!form.querySelector('[name="_gotcha"]')) {
      var t = document.createElement('input');
      t.type = 'text'; t.name = '_gotcha'; t.tabIndex = -1;
      t.autocomplete = 'off'; t.setAttribute('aria-hidden', 'true');
      t.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0';
      form.appendChild(t);
    }

    Array.prototype.forEach.call(form.querySelectorAll('input, select, textarea'), function (f) {
      f.addEventListener('input', function () { if (f.classList.contains('has-error')) clearError(f); });
      f.addEventListener('blur', function () { if (f.hasAttribute('required') && (f.value || '').trim()) clearError(f); });
    });

    form.addEventListener('submit', function (e) {
      var s = form.querySelector('.form-status');
      if (s) s.remove();
      if (form.querySelector('[name="_gotcha"]').value) { e.preventDefault(); return; }
      if (!validate(form)) { e.preventDefault(); return; }

      if (shopifyContact) {
        /* fold every field into contact[body] so it shows up in Shopify's
           default notification email, then let the real POST go through */
        var bodyField = form.querySelector('#lm-body, [name="contact[body]"]');
        if (bodyField) bodyField.value = summarise(form);
        try { sessionStorage.setItem('leadModalPending', '1'); } catch (err) { /* ignore */ }
        return; /* do not preventDefault: this one submits for real */
      }

      e.preventDefault();
      if (ENDPOINT) submit(form); else showFallback(form);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('form'), wire);
    Array.prototype.forEach.call(document.querySelectorAll('[data-count-for]'), counter);
    checkShopifyContactRedirect();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* modals inject their form after load */
  window.addEventListener('load', init);
})();